import type {SketchStyleSplineObject} from '../sketch/SketchStyleSplineObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图风格样条对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图风格样条协议时返回 true。
 */
export function isSketchStyleSplineObject(value: unknown): value is SketchStyleSplineObject {
	// 统一通过运行时标记字段识别对象类型。
	return hasRuntimeFlag(value, 'isSketchStyleSplineObject');
}
